import React, { useEffect, useState } from "react";
import useModalStore from "../StatesStore/ModalStore";
import algoliasearch from "algoliasearch";
import { X } from "react-bootstrap-icons";
import {
  Form,
  Modal,
  Button,
  CloseButton,
  OverlayTrigger,
  Tooltip,
} from "react-bootstrap";
import { message } from "antd";
import { UserAuth } from "../Context";
import { saveInviteToDb } from "../lib/saveInviteToDb";
import { checkIfEmailExists } from "../lib/checkIfEmailExists";
import { Link } from "react-router-dom";
import { getBaseURL } from "../lib/getBaseURL";
import { collection, doc, getDoc, getDocs } from "firebase/firestore";
import { db } from "../FirebaseConfig";
import { toast } from "react-toastify";
import { toastOptions } from "../lib/toastOptions";
import { encryptChat } from "../ShoppingList/Encryption";
import { generateChatId } from "../Chat/lib.js/generateChatId";
import { saveMessageToDB } from "../Chat/lib.js/saveMsgToDb";
import useChatClient from "../StatesStore/ChatClient";
import { usePointsSystem } from "../Points/usePointsSystem";
import LoadingSpinner from "../UserProfile/LoadingSpinner";
import CheckStatus from "../lib/checkUserStatus";
import { CopyLink, WhatsApp, Facebook } from "../ShoppingList/SocialMediaSVGs";
import BottomTray from "../Trays/BottomTray";
import AskAFriend from "../Trays/AskAFriend";
const { GetFeedBack } = require("../EmailSystem/sendEmails");

function AddToChat3({ product, componentName }) {
  const baseURL = getBaseURL();
  const data = `${baseURL}/#/ProductDetails/${product?.id}`;
  const [showModal, setShowModal] = useState(false);
  const { openModal } = useModalStore();
  const [Error, setError] = useState("");
  const { user } = UserAuth();
  const { awardPoints } = usePointsSystem(user?.uid);
  const text = "Ask A Friend";
  const myEmail = user?.providerData[0].email;
  const modified = data.replace(
    "http://localhost:3000",
    "https://lookflock.com"
  );
  const [inviteOption, setInviteOption] = useState("users");
  const [input, setInput] = useState("");
  const [searchedUsers, setSearchedUsers] = useState([]);
  const [isFriendsDataEmpty, setIsFriendsDataEmpty] = useState(false);
  const algoliaClient = algoliasearch(
    process.env.REACT_APP_ALGOLIA_APP_ID,
    process.env.REACT_APP_ALGOLIA_ADMIN_KEY
  );
  const indexUsers = algoliaClient.initIndex("users"); // Name of index in Algolia is users
  const client = useChatClient((state) => state.client);
  const [isSmallScreen, setIsSmallScreen] = useState(window.innerWidth < 768);
  const [showSecondaryModal, setShowSecondaryModal] = useState(false);
  const [content, setContent] = useState("");
  const [friends, setFriends] = useState([]);
  const [selectedFriends, setSelectedFriends] = useState([]);
  const [loading, setLoading] = useState(false);
  const [emailInputValue, setEmailInputValue] = useState("");
  const [emailUsers, setEmailUsers] = useState([]);
  const [searchLoading, setSearchLoading] = useState(false);
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    const handleResize = () => {
      setIsSmallScreen(window.innerWidth < 768);
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const handleCloseSecondaryModal = () => {
    // setSelectedFriends([]);
    setContent("");
    setShowSecondaryModal(false);
  };

  const checkEmails = async (email) => {
    if (email === myEmail) {
      setError("Cannot email yourself");
      return false; // Email is same as user's email
    }
    if (emailUsers.includes(email)) {
      setError("Emails should be unique");
      return false; // Duplicate found
    }
    const emailExists = await checkIfEmailExists(email);
    if (emailExists.exists) {
      const handleLinkClick = () => {
        handleClose(); // Close the modal when the link is clicked
      };

      const userLink = (
        <Link
          to={`/userProfile/${emailExists.userId}`}
          onClick={handleLinkClick}
        >
          {emailExists.firstName}
        </Link>
      );

      // Set the error state with the clickable link
      setError(
        <>
          {email} is already on Lookflock. Add {userLink} and invite them
          directly.
        </>
      );

      return false;
    }
    return true;
  };

  const isValidEmail = (email) =>
    /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email.trim());

  const onEmailFinish = async (values) => {
    if (values.length === 0) {
      if (isValidEmail(emailInputValue)) {
        if (await checkEmails(emailInputValue)) {
          values.push(emailInputValue);
        }
      } else {
        setError("Please enter a valid email");
        return;
      }
    }
    values.forEach(async (email) => {
      // console.log(user, data);

      GetFeedBack(user?.displayName, "", email, modified, content)
        .then(() => {
          message.success({
            content: `Email sent successfully to ${email}`,
            key: "success",
          });
        })
        .catch((error) => {
          message.error(`Error sending email to ${email}`);
          console.error("Error sending email:", error);
        });

      handleClose();
      await saveInviteToDb(
        {
          name: "",
          email,
          type: "email",
        },
        user
      );
    });
  };

  const handleCopyLink = () => {
    const fullLink = data.replace(
      "http://localhost:3000",
      "https://lookflock.com"
    );
    navigator.clipboard.writeText(fullLink); // Copy link to clipboard
    message.success({
      content: `Link copied`,
      key: "success",
    });
  };

  const handleFacebookShare = () => {
    const shareQuote = encodeURIComponent(text);
    window.open(
      `https://www.facebook.com/sharer/sharer.php?u=https://lookflock.com/#/ProductDetails/${text}&quote=${shareQuote}`
    );
  };

  const handleWhatsappShare = () => {
    window.open(
      `https://api.whatsapp.com/send?text=${encodeURIComponent(
        `${text}: ${data}`
      )}`
    );
  };

  const handleEmailChange = (e) => {
    setError("");
    setEmailInputValue(e.target.value);
  };

  const handleSearchBar = async (event) => {
    event.preventDefault();
    setSearchLoading(true);
    const itemsPerPage = 12;

    if (input.trim().length >= 3) {
      const searchQuery = `${input.trim()}`;
      // console.log("Search input: ", searchQuery);
      try {
        const data = await indexUsers.search(searchQuery, {
          length: itemsPerPage,
        });
        const uniqueUsers = new Set([...data.hits]);
        let updatedUsers = Array.from(uniqueUsers);
        console.log("updatedUsers", updatedUsers);
        if (updatedUsers.length === 0) {
          setIsFriendsDataEmpty(true);
        }
        // setSearchResults(updatedUsers);
        setSearchedUsers(updatedUsers);
      } catch (error) {
        console.error("Error fetching data: ", error);
      } finally {
        setSearchLoading(false);
      }
    } else {
      console.log("Please enter at least 3 characters to search.");
      setSearchLoading(false);
    }
  };

  const handleClick = () => {
    if (!user) {
      openModal("SignInModal", "", "");
    } else if (!user?.emailVerified) {
      openModal("VerifyEmailModal", "", {
        userName: user?.displayName,
        email: user?.email,
      });
    } else setShowModal(true);
  };

  const handleFriendSelect = (friendData) => {
    setSelectedFriends((prevSelected) => {
      if (prevSelected.some((f) => f.id === friendData.id)) {
        return prevSelected.filter((f) => f.id !== friendData.id);
      } else {
        return [...prevSelected, friendData];
        // return [friendId];
      }
    });
  };

  const handleSendMessage = async () => {
    if (!selectedFriends.length) {
      toast.warning("Please select at least one friend.", toastOptions);
      return;
    }
    const baseURL = getBaseURL();
    try {
      setLoading(true);
      await Promise.all(
        selectedFriends.map(async (friend) => {
          const msgData = {
            senderId: user.uid,
            receiverId: friend?.id,
            content: encryptChat(content),
            productId: product.id,
            type: "product",
          };
          // if (socket) {
          //   socket.emit("chat msg", msgToBeSent);
          //   // setMsgs((prevMsgs) => [...prevMsgs, msgToBeSent]);
          // }
          const channelId = generateChatId(user.uid, friend?.id);

          // Initialize the channel
          const channel = client.channel("messaging", channelId, {
            members: [user.uid, friend?.id],
          });
          await channel.watch();
          const attachments = [
            {
              image: product?.imageUrl,
              product,
              type: "product",
            },
          ];
          await channel.sendMessage({
            productId: product?.id,
            product: product,
            attachments,
          });
          if (content.trim()) {
            await channel.sendMessage({
              text: `${content}`,
              productId: product?.id,
              product: product,
            });
          }
          await saveMessageToDB(msgData);
        })
      );

      toast.success("Message sent!", toastOptions);
      awardPoints("askAFriend");
      setSelectedFriends([]); // Reset after sending
      setShowModal(false);
      setShowSecondaryModal(false);
      setIsOpen(false);
      setContent("");
      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.error("Error sending message:", error);
      toast.error("Failed to send message. Try again.", toastOptions);
    }
  };

  const fetchFriends = async () => {
    if (!user) return;

    const connectionsRef = collection(db, "users", user.uid, "connections");
    const activeFriendsSnapshot = await getDocs(connectionsRef);
    const activeFriends = activeFriendsSnapshot.docs
      .filter((doc) => doc.data().type === "active")
      .map((doc) => doc.id); // Get only the friend's document ID (friendId)

    // Fetch the userName for each active friend
    const friendsWithNames = await Promise.all(
      activeFriends.map(async (friendId) => {
        const friendDocRef = doc(db, "users", friendId); // Reference to the friend's doc
        const friendDoc = await getDoc(friendDocRef);
        if (friendDoc.exists()) {
          const friendData = friendDoc.data();
          return {
            id: friendId,
            name: friendData.userName, // Get the userName from the document
            photo: friendData.photo,
          };
        } else {
          console.error("No such friend document!");
          return null;
        }
      })
    );

    // Filter out null values (if any friend documents were not found)
    setFriends(friendsWithNames.filter((friend) => friend !== null));
    // console.log(
    //   "Friends",
    //   friendsWithNames.filter((friend) => friend !== null)
    // );
  };

  const removeEmail = (removeIndex) => {
    setEmailUsers(emailUsers.filter((_, index) => index !== removeIndex));
  };

  const handleKeyDown = async (e) => {
    if (["Enter", ",", " "].includes(e.key)) {
      e.preventDefault();
      const trimmed = emailInputValue.trim().replace(/,$/, "");
      if (
        trimmed &&
        isValidEmail(trimmed) &&
        (await checkEmails(e.target.value))
      ) {
        if (!emailUsers.includes(trimmed)) {
          setEmailUsers([...emailUsers, trimmed]);
        }
        setEmailInputValue("");
      }
    }
  };

  const handleClose = () => {
    setShowModal(false);
    setIsOpen(false);
    setIsFriendsDataEmpty(false);
    setInput("");
    setContent("");
    setInviteOption("users");
    setError("");
    setEmailUsers([]);
    setEmailInputValue("");
    // setListMembers({});
    setSelectedFriends([]);
    setSearchedUsers([]);
  };
  useEffect(() => {
    if (user) {
      fetchFriends();
    }
  }, [user, showModal]);
  return (
    <>
      <div
        className="d-flex align-items-center justify-content-center w-100"
        style={{
          borderRadius: "0px 0px 0px 3px",
          height: componentName === "productCard" ? "31px" : "40px",
          cursor: "pointer",
          backgroundColor: "#F4F4F4",
        }}
        onClick={() => {
          if (isSmallScreen) {
            setIsOpen(true);
          } else {
            handleClick();
          }
        }}
      >
        <div
          style={{
            fontFamily: "Inter",
            fontWeight: "400",
            fontSize:
              componentName === "productCard"
                ? isSmallScreen
                  ? "11px"
                  : "14px"
                : isSmallScreen
                ? "14px"
                : "16px",
            lineHeight: "100%",
            letterSpacing: "0%",
            textAlign: "center",
            color: "#676A79",
          }}
        >
          Ask a Friend
        </div>
      </div>
      <style jsx>
        {`
          .askAFriendModal .modal-content {
            border-radius: 20px !important;
            width: 36rem;
            overflow: hidden;
            max-height: 660px;
          }

          .askAFriendModal .modal-dialog {
            max-width: 36rem;
            margin: 1rem auto; /* Add some margin */
          }
        `}
      </style>
      <BottomTray
        isOpen={isOpen}
        setIsOpen={setIsOpen}
        onClose={handleClose}
        text="Ask a Friend"
      >
        <AskAFriend
          inviteOption={inviteOption}
          setInviteOption={setInviteOption}
          onEmailFinish={onEmailFinish}
          emailUsers={emailUsers}
          removeEmail={removeEmail}
          emailInputValue={emailInputValue}
          handleEmailChange={handleEmailChange}
          handleKeyDown={handleKeyDown}
          content={content}
          setContent={setContent}
          handleSearchBar={handleSearchBar}
          input={input}
          setInput={setInput}
          setIsFriendsDataEmpty={setIsFriendsDataEmpty}
          searchLoading={searchLoading}
          selectedFriends={selectedFriends}
          handleFriendSelect={handleFriendSelect}
          searchedUsers={searchedUsers}
          isFriendsDataEmpty={isFriendsDataEmpty}
          loading={loading}
          handleCopyLink={handleCopyLink}
          handleFacebookShare={handleFacebookShare}
          handleWhatsappShare={handleWhatsappShare}
          handleSendMessage={handleSendMessage}
          Error={Error}
        />
      </BottomTray>
      <Modal
        show={showModal}
        onHide={handleClose}
        centered
        className="askAFriendModal"
      >
        <Modal.Body style={{ padding: isSmallScreen ? "20px" : "40px" }}>
          <div className="d-flex flex-column" style={{ gap: "24px" }}>
            <div className="d-flex w-100 justify-content-between align-items-center">
              <div
                style={{
                  fontFamily: "Inter",
                  color: "#101828",
                  fontWeight: "600",
                  fontSize: isSmallScreen ? "18px" : "24px",
                  lineHeight: isSmallScreen ? "18px" : "24px",
                  letterSpacing: "0%",
                }}
              >
                Ask A Friend
              </div>
              <button
                type="button"
                style={{
                  boxSizing: "border-box",
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "center",
                  alignItems: "center",
                  width: "27px",
                  height: "27px",
                  background: "#FFFFFF",
                  border: "1px solid #FF3B30",
                  boxShadow: "1px 1px 5px rgba(30, 30, 30, 0.14)",
                  borderRadius: "25px",
                  flex: "none",
                  order: "1",
                  flexGrow: "0",
                }}
                onClick={handleClose}
              >
                <svg
                  style={{ width: "11px" }}
                  width="14"
                  height="14"
                  viewBox="0 0 14 14"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M13 1L1 13M1 1L13 13"
                    stroke="#FF3B30"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              </button>
            </div>
            {/* Tabs for Users/Brands */}
            <div className="d-flex flex-column " style={{ gap: "12px" }}>
              <div
                className="d-flex align-items-center"
                style={{ gap: "60px" }}
              >
                <div
                  onClick={() => setInviteOption("users")}
                  className="linkStyle"
                  style={{
                    borderBottom:
                      inviteOption === "users"
                        ? `1px solid rgb(0, 95, 218)`
                        : "",
                    color: inviteOption === "users" ? "#005FDA" : "#667085",
                    fontSize: "18px",
                    fontWeight: 500,
                    margin: 0,
                    cursor: "pointer",
                  }}
                >
                  Users
                </div>
                <div
                  onClick={() => setInviteOption("email")}
                  className="linkStyle"
                  style={{
                    borderBottom:
                      inviteOption === "email"
                        ? `1px solid rgb(0, 95, 218)`
                        : "",
                    color: inviteOption === "email" ? "#005FDA" : "#667085",
                    fontSize: "18px",
                    fontWeight: 500,
                    margin: 0,
                    cursor: "pointer",
                  }}
                >
                  Email
                </div>
              </div>
              <div className="d-flex flex-column " style={{ gap: "24px" }}>
                {inviteOption === "email" ? (
                  <Form
                    className="d-flex flex-column gap-1"
                    onSubmit={async (e) => {
                      e.preventDefault();
                      onEmailFinish(emailUsers);
                    }}
                  >
                    <div>
                      {emailUsers.length > 0 && (
                        <div
                          className="d-flex align-items-center gap-2 mb-2"
                          style={{
                            overflowX: "auto",
                            scrollbarWidth: "thin",
                            paddingBottom: "4px",
                          }}
                        >
                          {emailUsers.map((email, index) => (
                            <Button
                              key={index}
                              size="sm"
                              variant="primary-soft"
                              className="d-flex align-items-center"
                            >
                              {email}
                              <CloseButton
                                className="ms-2"
                                onClick={() => removeEmail(index)}
                              />
                            </Button>
                          ))}
                        </div>
                      )}
                      <div className="d-flex gap-2 align-items-center">
                        <Form.Control
                          type="text"
                          placeholder="email@example.com"
                          className="rounded-2 h-50"
                          value={emailInputValue}
                          onChange={handleEmailChange}
                          onKeyDown={handleKeyDown}
                        />
                        <OverlayTrigger
                          placement="right"
                          overlay={
                            <Tooltip>
                              Press enter after typing each email address. You
                              can add up to 10 email addresses.
                            </Tooltip>
                          }
                        >
                          <i
                            style={{ cursor: "pointer", color: "#0f6fec" }}
                            className="bi bi-info-circle"
                          ></i>
                        </OverlayTrigger>
                      </div>
                    </div>
                    <span className="text-danger">{Error}</span>
                    <div className="mt-0">
                      <textarea
                        className="form-control rounded-2"
                        rows="2"
                        placeholder="Add a note or message (Optional)"
                        value={content}
                        onChange={(e) => setContent(e.target.value)}
                        maxLength={300}
                      />
                      <small>Character limit: 300</small>
                    </div>
                    <div className="d-flex justify-content-end mt-3">
                      <Button
                        className="rounded-3 w-100"
                        type="submit"
                        variant="primary"
                        disabled={
                          emailUsers.length === 0 &&
                          emailInputValue.length === 0
                        }
                      >
                        <span>Ask</span>
                      </Button>
                    </div>
                  </Form>
                ) : (
                  <form onSubmit={(event) => handleSearchBar(event)}>
                    <div className="input-group gap-2">
                      <input
                        type="text"
                        className="form-control rounded-3"
                        placeholder="Search by name or email"
                        value={input}
                        onChange={(e) => {
                          setInput(e.target.value);
                          setIsFriendsDataEmpty(false);
                        }}
                        required
                      />
                      <button
                        style={{ width: "6rem" }}
                        className="btn btn-primary rounded-3"
                        type="submit"
                      >
                        {searchLoading ? (
                          <LoadingSpinner height="10px" spinnerSize="20px" />
                        ) : (
                          "Search"
                        )}
                      </button>
                    </div>
                    {selectedFriends.length > 0 && (
                      <div
                        className="alphabet-list navbar thinScrollBar py-2"
                        style={{ overflowX: "auto" }}
                      >
                        <ul className="nav d-flex flex-row flex-nowrap list-unstyled gap-2 pt-1 ">
                          {selectedFriends.map((friend) => {
                            return (
                              <li
                                key={friend.objectID}
                                className="btn rounded-2 btn-sm btn-primary-soft  d-flex gap-2 align-items-center ps-1 py-1"
                                onClick={() =>
                                  handleFriendSelect({
                                    id: friend.id,
                                    name: friend.name,
                                  })
                                }
                              >
                                <X className="fs-5 " />

                                <div style={{ whiteSpace: "nowrap" }}>
                                  {friend.name}
                                </div>
                              </li>
                            );
                          })}
                        </ul>
                      </div>
                    )}
                    {/* <hr /> */}
                    {searchedUsers?.length > 0 && (
                      <>
                        <div
                          className="d-flex flex-column mt-2"
                          style={{ maxHeight: "12rem", overflowY: "auto" }}
                        >
                          {searchedUsers?.map((searchedUser, index) => {
                            return (
                              <div
                                key={searchedUser.objectID}
                                className="d-flex justify-content-between align-items-center w-100 my-1"
                                style={{ cursor: "pointer" }}
                                onClick={() => {
                                  handleFriendSelect({
                                    id: searchedUser?.objectID,
                                    name: searchedUser?.displayName,
                                  });
                                }}
                              >
                                <div
                                  className="d-flex align-items-center"
                                  style={{ gap: "6px" }}
                                >
                                  <input
                                    name="members"
                                    type="checkbox"
                                    className="form-check-input"
                                    checked={selectedFriends.some(
                                      (f) => f.id === searchedUser?.objectID
                                    )}
                                  />
                                  <img
                                    src={
                                      searchedUser?.objectUser?.photo ||
                                      `https://ui-avatars.com/api/?name=${searchedUser?.objectUser?.userName[0]?.toUpperCase()}`
                                    }
                                    style={{
                                      borderRadius: "8px",
                                      width: isSmallScreen ? "40px" : "48px",
                                      height: isSmallScreen ? "40px" : "48px",
                                      objectFit: "cover",
                                    }}
                                    loading="lazy"
                                    alt=""
                                  />
                                  <div
                                    className="d-flex flex-column"
                                    style={{ gap: "2px" }}
                                  >
                                    <div
                                      style={{
                                        fontFamily: "Inter",
                                        fontSize: "16px",
                                        fontWeight: 600,
                                        lineHeight: "100%",
                                        letterSpacing: "0%",
                                        color: "black",
                                      }}
                                    >
                                      {searchedUser?.displayName}
                                    </div>
                                    <CheckStatus
                                      myUid={user?.uid}
                                      yourEmail={searchedUser?.email}
                                    />
                                  </div>
                                </div>
                              </div>
                            );
                          })}
                        </div>
                      </>
                    )}
                    {isFriendsDataEmpty && (
                      <div className="text-center pt-3">
                        <div className="h5 mb-0">No users found</div>
                      </div>
                    )}
                  </form>
                )}
                {searchedUsers?.length > 0 &&
                  inviteOption === "users" &&
                  (loading ? (
                    <button
                      type="button"
                      className="btn btn-primary w-100 rounded-3"
                    >
                      <LoadingSpinner spinnerSize="1rem" height="1.5rem" />
                    </button>
                  ) : (
                    <button
                      onClick={() => setShowSecondaryModal(true)}
                      type="button"
                      disabled={selectedFriends.length === 0}
                      className="btn btn-primary w-100 rounded-3"
                    >
                      Ask
                    </button>
                  ))}
                <div className="d-flex flex-column" style={{ gap: "4px" }}>
                  <div
                    style={{
                      fontFamily: "Inter",
                      fontWeight: 500,
                      fontSize: "16px",
                      lineHeight: "100%",
                      letterSpacing: "0%",
                      color: "black",
                    }}
                  >
                    Share By
                  </div>
                  <div
                    className="d-flex justify-content-center"
                    style={{ gap: "16px" }}
                  >
                    <span
                      style={{ cursor: "pointer" }}
                      onClick={handleFacebookShare}
                    >
                      <Facebook />
                    </span>
                    <span
                      style={{ cursor: "pointer" }}
                      onClick={handleWhatsappShare}
                    >
                      <WhatsApp />
                    </span>
                    <span
                      style={{ cursor: "pointer" }}
                      onClick={handleCopyLink}
                    >
                      <CopyLink />
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Modal.Body>
      </Modal>
      <Modal
        show={showSecondaryModal}
        onHide={handleCloseSecondaryModal}
        centered
        className="secondaryModal"
      >
        <Modal.Body style={{ padding: isSmallScreen ? "1rem" : "2rem" }}>
          <div className="d-flex flex-column mb-3">
            <div className="d-flex w-100 justify-content-between">
              <div className="h4">
                Send message to{" "}
                {selectedFriends.length === 1
                  ? friends.find((f) => f.id === selectedFriends[0]?.id)
                      ?.name ??
                    searchedUsers.find(
                      (f) => f.objectID === selectedFriends[0]?.id
                    )?.displayName
                  : `${selectedFriends.length} friends`}
              </div>

              <button
                type="button"
                style={{
                  boxSizing: "border-box",
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "center",
                  alignItems: "center",
                  width: "27px",
                  height: "27px",
                  background: "#FFFFFF",
                  border: "1px solid #FF3B30",
                  boxShadow: "1px 1px 5px rgba(30, 30, 30, 0.14)",
                  borderRadius: "25px",
                  flex: "none",
                  order: "1",
                  flexGrow: "0",
                }}
                onClick={handleCloseSecondaryModal}
              >
                <svg
                  style={{ width: "11px" }}
                  width="14"
                  height="14"
                  viewBox="0 0 14 14"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M13 1L1 13M1 1L13 13"
                    stroke="#FF3B30"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
              </button>
            </div>
            <p className="m-0">
              Send a message to your friend to ask about the product you like.
            </p>
          </div>
          <div className="input-group d-flex flex-column gap-3 mt-1">
            <textarea
              className="form-control form-control-sm w-100 shadow-lg rounded-3"
              placeholder="Type your message here"
              style={{ height: "100px" }}
              value={content}
              onChange={(e) => setContent(e.target.value)}
            />
            <div className="w-100 btn btn-primary rounded-3">
              {loading ? (
                <div className="spinner-border spinner-border-sm" role="status">
                  <span className="visually-hidden">Loading...</span>
                </div>
              ) : (
                <div onClick={handleSendMessage}>Send</div>
              )}
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
}

export default AddToChat3;
